import React from "react";

export default function Real_time_vehicles_Coral(props) {
  let { data } = props;
  return (
    <>
      {data.length === 0
        ? <tr><td colSpan={6}>No data found</td></tr>
        : data.map((x, index) => {
          return (
            <tr key={index}>
              <td scope="row">{index + 1}</td>
              <td scope="row">{x._source.vehicleId}</td>
              <td scope="row">{x._source.DLR_ORG_CITY}</td>
              <td scope="row">{x._source.Distance_to_Empty}</td>
              <td scope="row">{x._source.DLR_REGION}</td>
              <td scope="row">{x._source.BMS_Pack_SOH}</td>
              <td scope="row">{x._source.State_of_Charge_SOC}</td>
            </tr>
          );
        })}
    </>
  );
}
